export default __webpack_public_path__ + "static/thumb-2b21f21f34006999d2cf1725de80af51.png";